module.exports = __webpack_public_path__ + "img/tick.4cc6f5d3.svg";